document.addEventListener('DOMContentLoaded', () => {
  gsap.registerPlugin(ScrollTrigger);

  // =================
  // YouTube Hover Play
  // =================
  document.querySelectorAll('.youtube-player iframe').forEach((iframe) => {
    const container = iframe.closest('.youtube-player');

    if (!container) return;

    ['mouseenter', 'mouseleave'].forEach((event) => {
      container.addEventListener(event, () => {
        iframe.contentWindow.postMessage(
          JSON.stringify({
            event: 'command',
            func: event === 'mouseenter' ? 'playVideo' : 'pauseVideo',
          }),
          '*'
        );
      });
    });
  });

  // =================
  // ScrollTrigger Cards
  // =================
  const section = document.querySelector('.our-story__block');
  const panels = gsap.utils.toArray('.our_story__testimonial-item');

  if (section && panels.length) {
    const mm = gsap.matchMedia();

    mm.add(
      {
        desktop: '(min-width: 960px)',
        mobile: '(max-width: 959px)',
      },
      (ctx) => {
        const { desktop, mobile } = ctx.conditions;

        // =========================
        // DESKTOP
        // =========================
        if (desktop) {
          gsap.set(section, {
            height: '100%',
            position: 'relative',
            overflow: 'hidden',
          });

          panels.forEach((panel, i) => {
            gsap.set(panel, {
              position: 'absolute',
              inset: 0,
              yPercent: i === 0 ? 0 : 150,
              zIndex: i + 1,
              visibility: i === 0 ? 'visible' : 'hidden',
              willChange: 'transform',
            });
          });

          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: section,
              start: 'top top',
              end: `+=${window.innerHeight * (panels.length - 1)}`,
              scrub: true,
              pin: true,
              anticipatePin: 1,
            },
          });

          panels.forEach((panel, i) => {
            if (i === panels.length - 1) return;

            const nextPanel = panels[i + 1];

            tl.set(nextPanel, { visibility: 'visible' }, i).to(
              nextPanel,
              {
                yPercent: 0,
                ease: 'none',
              },
              i
            );
          });
        }

        // =========================
        // MOBILE
        // =========================
        if (mobile) {
          const wrapper = document.querySelector('.our_story__testimonial-list');
          let slides = gsap.utils.toArray('.our_story__testimonial-item');

          // clone first slide
          wrapper.appendChild(slides[0].cloneNode(true));
          slides = gsap.utils.toArray('.our_story__testimonial-item');

          gsap.set(wrapper, {
            display: 'flex',
            gap: '32px',
            flexWrap: 'nowrap',
          });

          gsap.set(slides, {
            flex: '0 0 100%',
          });

          let index = 0;

          function goToSlide(i) {
            gsap.to(wrapper, {
              x: -slides[i].offsetLeft,
              duration: 0.9,
              ease: 'power2.inOut',
              onComplete: () => {
                // if we're on cloned slide
                if (i === slides.length - 1) {
                  gsap.set(wrapper, { x: 0 });
                  index = 0;
                }
              },
            });
          }

          const tl = gsap.timeline({
            repeat: -1,
          });

          tl.call(() => goToSlide(index++))
            .to({}, { duration: 4 })
            .repeat(-1);
        }
        return () => mm.revert();
      }
    );
  }

  // ================================
  // Scroll Reveal Utility
  // ================================
  function animateCardsOnScroll(selector, options = {}) {
    const {
      start = 'top 90%',
      y = 40,
      scale = 0.95,
      duration = 0.6,
      ease = 'back.out(1.5)',
      stagger = 0.15,
      alternateX = false,
      xDistance = 100,
      useBatch = false,
    } = options;

    const elements = gsap.utils.toArray(selector).filter((el) => {
      if (el.dataset.gsapInit) return false;
      el.dataset.gsapInit = '1';
      return true;
    });

    if (!elements.length) return;

    // INIT STATE
    gsap.set(elements, {
      opacity: 0,
      y,
      scale,
      x: 0,
    });

    // INIT LEFT/RIGHT ONLY FOR ALTERNATE SECTIONS
    if (alternateX) {
      elements.forEach((el, index) => {
        gsap.set(el, {
          x: index % 2 === 0 ? -xDistance : xDistance,
        });
      });
    }

    // ONE BY ONE ANIMATION (for grid sections)
    if (useBatch) {
      ScrollTrigger.batch(elements, {
        start,
        once: true,
        onEnter: (batch) => {
          gsap.to(batch, {
            opacity: 1,
            y: 0,
            x: 0,
            scale: 1,
            duration,
            ease,
            stagger,
          });
        },
      });
    } else {
      // default individual animation
      elements.forEach((el) => {
        ScrollTrigger.create({
          trigger: el,
          start,
          once: true,
          onEnter: () => {
            gsap.to(el, {
              opacity: 1,
              y: 0,
              x: 0,
              scale: 1,
              duration,
              ease,
            });
          },
        });
      });
    }
  }

  window.initScrollAnimations = function () {
    animateCardsOnScroll('.featured--news .card-wrap .news-item', { useBatch: true, y: 60, scale: 0.9 });
    animateCardsOnScroll('.gallery-wrap .gallery-item', { useBatch: true, y: 60, scale: 0.9 });
    animateCardsOnScroll('.project-grid .project-item', { useBatch: true, y: 60, scale: 0.9 });
    animateCardsOnScroll('.content-wrap .news-item', { useBatch: true, y: 60, scale: 0.9 });
    animateCardsOnScroll('.partner-card', { useBatch: true, y: 60, scale: 0.9 });
    animateCardsOnScroll('.project-grid .project-link', { useBatch: true, y: 60, scale: 0.9 });
    animateCardsOnScroll('.initiative-list .initiative-card', { useBatch: true, y: 60, scale: 0.9 });
    animateCardsOnScroll('.story-grid .story-card', { useBatch: true, y: 60, scale: 0.9 });
    animateCardsOnScroll('.our-story__wrapper .detail--section--wrap');
    animateCardsOnScroll('.initiative--wrapper > *', { alternateX: true, y: 0 });
    animateCardsOnScroll('.team-details-wrap > *', { alternateX: true, y: 0 });
  };

  window.initScrollAnimations();
});

// =================
// Page Load Animation
// =================
window.addEventListener('DOMContentLoaded', () => {
  const waitForSpans = () => {
    const title = document.querySelector('.banner__title');
    const spans = document.querySelectorAll('.banner__title .heading--style1 > span');

    if (!title || spans.length === 0) {
      requestAnimationFrame(waitForSpans);
      return;
    }

    initHeroAnimation(title, spans);
  };

  waitForSpans();
});

function initHeroAnimation(title, spans) {
  gsap.set(title, { visibility: 'visible' });

  const tl = gsap.timeline({
    defaults: { duration: 0.5, ease: 'power3.out' },
  });

  // =================
  // Header Animation First
  // =================
  tl.fromTo(
    '.home .header',
    { opacity: 0, yPercent: -50 },
    { opacity: 1, yPercent: 0, clearProps: 'transform' },
    '+=0.4'
  );

  // =================
  // Video Animation
  // =================
  tl.fromTo(
    '.hero-video video',
    {
      opacity: 0,
      scaleY: 0,
      transformOrigin: 'top center',
    },
    {
      opacity: 1,
      scaleY: 1,
      duration: 1.2,
      ease: 'power2.out',
    },
    'start'
  );

  // =================
  // Title Span Animation One By One
  // =================
  tl.fromTo(
    spans,
    { opacity: 0, x: -100 },
    {
      opacity: 1,
      x: 0,
      stagger: 0.3,
      clearProps: 'transform',
    },
    'start+=0.2'
  );

  // =================
  // Button Animation
  // =================
  tl.fromTo('.banner__wrapper .banner__btn', { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.2 }, '+=0.2');

  // =================
  // Hero Banner Animation
  // =================
  const heroBanner = document.querySelector('.hero--banner--block');
  if (heroBanner) {
    const toggleSticky = () => {
      if (window.scrollY >= window.innerHeight) {
        heroBanner.classList.add('sticky-disabled');
      } else {
        heroBanner.classList.remove('sticky-disabled');
      }
    };

    toggleSticky();
    window.addEventListener('scroll', toggleSticky, { passive: true });
    window.addEventListener('resize', toggleSticky);
  }
}

// =================
// Counter Animation
// =================
window.addEventListener('load', () => {
  const counters = document.querySelectorAll('.number__count');

  const animateCounter = (counter) => {
    const target = parseInt(counter.textContent.trim(), 10);
    if (isNaN(target)) return;

    let current = 0;
    const stepTime = Math.max(Math.floor(1000 / target), 20);

    counter.textContent = '0';

    const timer = setInterval(() => {
      current++;
      counter.textContent = current;

      if (current >= target) {
        clearInterval(timer);
        counter.textContent = target;
      }
    }, stepTime);
  };

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        animateCounter(entry.target);
        obs.unobserve(entry.target);
      });
    },
    { threshold: 0.4 }
  );

  counters.forEach((c) => observer.observe(c));
});

// =================
// Bike Animation
// =================
window.addEventListener('load', () => {
  initProjectBike();
  init404Bike();
});

// =================
// Shared Helpers
// =================
function rotateBikeParts(wheels, pedals, duration = 2) {
  gsap.to(wheels, {
    rotation: 360,
    transformOrigin: '50% 50%',
    duration,
    ease: 'none',
    repeat: -1,
  });

  if (pedals) {
    gsap.to(pedals, {
      rotation: 360,
      transformOrigin: '50% 50%',
      duration,
      ease: 'none',
      repeat: -1,
    });
  }
}

// =================
// Project Bike
// =================
function initProjectBike() {
  const bike = document.querySelector('.our--project #bicycle');

  if (!bike) return;

  const wheels = bike.querySelectorAll('#wheel-back, #wheel-front');
  const pedals = bike.querySelector('#pedals');

  const bikeWidth = bike.getBoundingClientRect().width;

  gsap.set(bike, {
    x: -bikeWidth,
  });

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: '.cycle',
      start: 'top 95%',
      end: 'bottom top',
      scrub: 1,
      invalidateOnRefresh: true,
    },
  });

  tl.to(
    bike,
    {
      x: () => window.innerWidth + bikeWidth,
      ease: 'none',
    },
    0
  )
    .to(
      wheels,
      {
        rotation: 2160,
        transformOrigin: 'center center',
        ease: 'none',
      },
      0
    )
    .to(
      pedals,
      {
        rotation: 720,
        transformOrigin: 'center center',
        ease: 'none',
      },
      0
    );

  ScrollTrigger.refresh();
}

// =================
// 404 Bike
// =================
function init404Bike() {
  const cycle = document.querySelector('.not-found #cycle');

  if (!cycle) return;

  const wheels = cycle.querySelectorAll('#wheel-front, #wheel-back');
  const pedals = cycle.querySelector('#pedals');

  cycle.style.overflow = 'visible';

  let moveTween;

  const animateBike = () => {
    if (moveTween) {
      moveTween.kill();
    }

    moveTween = gsap.fromTo(
      cycle,
      {
        x: -100,
      },
      {
        x: '110vw',
        duration: 25,
        ease: 'none',
        repeat: -1,
      }
    );
  };

  animateBike();
  rotateBikeParts(wheels, pedals);

  window.addEventListener('resize', animateBike);
}

// youtube
document.addEventListener('DOMContentLoaded', () => {
  const videoWrap = document.querySelector('.wp-block-embed__wrapper');
  const videoBtn = document.querySelector('.wp-block-embed__wrapper iframe button');

  if (videoWrap && videoBtn) {
    videoBtn.addEventListener('click', () => {
      videoWrap.classList.toggle('is-playing');
    });
  }
});

// Projects dropdown
jQuery(function ($) {
  const $filterTabs = $('.filter-tabs');
  if (!$filterTabs.length) {
    return;
  }
  // Current category is the dropdown trigger
  $filterTabs.on('click', '.filter-tabs__current .filter-tabs__btn', function (e) {
    e.preventDefault();

    $filterTabs.toggleClass('is-open');
  });
  // Category option
  $filterTabs.on('click', 'li:not(.filter-tabs__current) .filter-tabs__btn', function () {
    // Close dropdown
    $filterTabs.removeClass('is-open');
  });
  // Close outside
  $(document).on('click', function (e) {
    if (!$(e.target).closest('.filter-dropdown-wrap').length) {
      $filterTabs.removeClass('is-open');
    }
  });
});
